import React, { useEffect } from 'react'
import { DisplaysScreenShotsMethods, IDisplaysScreenShotsProps, IState } from './displays__screenShots.local.methods'
import DisplaysScreenShotsSidebar from './_sidebar/displays__screenShots_sidebar'
import ImageView from 'blocks.simple/imageView/imageView'
import type { ImageViewZoomStatus } from 'blocks.simple/imageView/imageView.types'
import Icon from 'blocks.simple/icon/icon'
import Modal from 'blocks.simple/modal/modal'
import PreviewMedia from 'blocks.app/preview/__media/preview__media'
import { api } from 'core/api/ConnectionManager'
import translate from 'core/translate'
import { cn } from 'ethcss'
import styles from './displays__screenShots.jcss'
import grid from 'blocks.simple/grid/grid.jcss'
import './animation/animation.css'

const DisplaysScreenShots = (p_: IDisplaysScreenShotsProps) => {
    const { state, setState, onRotate, zoomIn, zoomOut, imageViewRef } = DisplaysScreenShotsMethods(p_)

    const startUpdateAnimation = () => {
        setState((prevState: IState) => {
            return {
                ...prevState,
                isScreenshotUpdating: true,
            }
        })
    }

    const stopUpdateAnimation = () => {
        setTimeout(() => {
            setState((prevState: IState) => {
                return {
                    ...prevState,
                    isScreenshotUpdating: false,
                }
            })
        }, 1000)
    }

    useEffect(() => {
        const listenersId: string[] = []

        api.addObserver('digitalSignageScreenshotCreated', stopUpdateAnimation, listenersId)

        return () => {
            listenersId.forEach((id) => api.removeObserver(id))
        }
    })

    const orientationWidth = () => {
        return p_.selectedInfo &&
            p_.selectedInfo.settings &&
            p_.selectedInfo.settings.autoScreenshot &&
            p_.selectedInfo.settings.autoScreenshot.width
            ? p_.selectedInfo.settings.autoScreenshot.width
            : p_.selectedInfo.resolutionWidth && p_.selectedInfo.resolutionWidth
    }

    const orientationHeight = () => {
        return p_.selectedInfo &&
            p_.selectedInfo.settings &&
            p_.selectedInfo.settings.autoScreenshot &&
            p_.selectedInfo.settings.autoScreenshot.height
            ? p_.selectedInfo.settings.autoScreenshot.height
            : p_.selectedInfo.resolutionHeight
    }

    return (
        <Modal open={p_.open} showCloseIcon={false} mod="content">
            {p_.selectedInfo && (
                <div className={styles.wrapper}>
                    <div className={styles.image}>
                        {state.type !== 'video' && (
                            <ImageView
                                ref={imageViewRef}
                                src={state.image}
                                title={state.caption}
                                rotate={state.rotate}
                                emptyText={translate('mediaFileNotSelected')}
                                zoomStatusChange={(zoomStatus: ImageViewZoomStatus) => {
                                    setState((prevState: IState) => {
                                        return {
                                            ...prevState,
                                            ...zoomStatus,
                                        }
                                    })
                                }}
                                controls={
                                    <React.Fragment>
                                        <Icon
                                            type="rotate"
                                            color="white"
                                            size={24}
                                            onClick={onRotate}
                                            containerClass={cn(grid.p_md)}
                                            tooltip={{ title: translate('rotate') }}
                                        />
                                        <Icon
                                            type="zoom_in_bold"
                                            color="white"
                                            size={24}
                                            disabled={state.maxZoom}
                                            onClick={zoomIn}
                                            containerClass={cn(grid.p_md)}
                                            tooltip={{ title: translate('zoomIn') }}
                                        />
                                        <Icon
                                            type="zoom_out_bold"
                                            color="white"
                                            size={24}
                                            disabled={state.minZoom}
                                            onClick={zoomOut}
                                            containerClass={cn(grid.p_md)}
                                            tooltip={{ title: translate('zoomOut') }}
                                        />
                                        {p_.selectedInfo.type !== 'group' && (
                                            <Icon
                                                type="update"
                                                color="white"
                                                size={24}
                                                disabled={p_.selectedInfo && p_.selectedInfo.status === 'offline'}
                                                onClick={() => {
                                                    startUpdateAnimation()

                                                    api.send('updateScreenshotCb', {
                                                        id: p_.selectedInfo.id,
                                                        width: orientationWidth(),
                                                        height: orientationHeight(),
                                                    })
                                                }}
                                                containerClass={cn(
                                                    grid.p_md,
                                                    state.isScreenshotUpdating ? 'rotateAnimation' : ''
                                                )}
                                                tooltip={{ title: translate('update') }}
                                            />
                                        )}
                                        <Icon
                                            type="close"
                                            color="white"
                                            size={24}
                                            onClick={p_.onClose}
                                            containerClass={cn(grid.p_md)}
                                            tooltip={{ title: translate('close') }}
                                        />
                                    </React.Fragment>
                                }
                            />
                        )}
                        {state.type === 'video' && (
                            <div className={grid.full}>
                                <div className={styles.empty}>
                                    <PreviewMedia url={state.url} item={state.item} onClose={p_.onClose} />
                                </div>
                            </div>
                        )}
                    </div>
                    <DisplaysScreenShotsSidebar
                        onChangeActive={(item: any) => {
                            let itemData = { ...item, item: { fileType: item.type } }

                            if (item.metadata) {
                                itemData.item = {
                                    ...itemData.item,
                                    ...item.metadata,
                                    src: item.url,
                                }
                            }

                            setState((prevState: IState) => {
                                return {
                                    ...prevState,
                                    ...itemData,
                                }
                            })
                        }}
                        onClose={p_.onClose}
                        minimized={state.minimized}
                        selectedInfo={p_.selectedInfo}
                        toggleMinimized={() => {
                            setState((prevState: IState) => {
                                return {
                                    ...prevState,
                                    minimized: !state.minimized,
                                }
                            })
                        }}
                        startUpdateAnimation={startUpdateAnimation}
                    />
                </div>
            )}
        </Modal>
    )
}

export default DisplaysScreenShots
